module.exports = __webpack_public_path__ + "img/ice_mountain_ball.663d4707.gif";